<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <br />
  <!-- FILTRAR USUÁRIOS-->
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Filtrar usuários</h3>
    </div>
    <div class="card-body">
      <div class="input-group mb-3">
        <input type="text" name="search" class="form-control" placeholder="Nome/email" v-model="filtro" />
        <span class="input-group-append">
          <button type="submit" class="btn btn-primary btn-sm" @click="searchUsers">Buscar</button>
        </span>
      </div>
    </div>
  </div>

  <!-- CRIAR USUÁRIO-->
  <criar-usuario-admin v-if="criar_usuario" :setCriarUsuario="setCriarUsuario" :usuarioCriado="usuarioCriado" />

  <button @click="criar_usuario = true" data-toggle="modal" data-target="#criar-user-modal" type="button" class="btn btn-primary btn-sm">
    Novo usuário
    <i style="margin-left: 5px" class="fa fa-plus"></i>
  </button>

  <!-- TABELA USUÁRIOS-->
  <div class="card card-primary">
    <div class="card-header">
      <h3 class="card-title">Usuários</h3>
    </div>
    <div class="card-body p-0">
      <table class="table">
        <thead>
          <tr>
            <th>Apelido</th>
            <th>Email</th>
            <th>Criação</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td data-label="Apelido">{{ user.apelido }}</td>
            <td data-label="Email">{{ user.email }}</td>
            <td data-label="Criação">{{ formatDate(user.created_at) }}</td>

            <td>
              <a
                id="navbarDropdown"
                class="nav-link"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-pre
              >
                <i class="fa-solid fa-bars" style="color: gray"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                <div class="dropdown-divider"></div>
                <a
                  style="cursor: pointer"
                  class="dropdown-item"
                  data-toggle="modal"
                  data-target="#edit-user-modal"
                  @click="selecionarUsuario(user), (editar_usuario = true)"
                >
                  <i class="fa-solid fa-x"></i>
                  &nbsp;&nbsp; Editar
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card-footer clearfix">
      <!-- TOTAIS  -->
      <div style="font-size: 13px" class="float-left" aria-live="polite">
        Exibindo do {{ inicio + 1 }} ao {{ inicio + users.length }}
        <p>Total {{ total }}</p>
      </div>

      <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

      <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="7">7</option>
        <option :value="15">15</option>
        <option :value="25">25</option>
      </select>

      <div class="card-tools">
        <div class="input-group input-group-sm" style="width: 150px"></div>
      </div>

      <!-- PAGINAÇÃO  -->
      <ul class="pagination pagination-sm m-0 float-right">
        <li class="page-item"><a class="page-link" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

        <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
          <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" @click="selecionarPagina(pagina)">
            {{ pagina }}
          </a>
        </li>

        <li class="page-item"><a class="page-link" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
      </ul>
    </div>
  </div>

  <!-- EDITAR USUÁRIO-->
  <editar-usuario-admin v-if="editar_usuario" :user="usuario_selecionado" :setEditarUsuario="setEditarUsuario" :usuarioEditado="usuarioEditado" />
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [sweetAlert, Swal],

  components: { Loading },

  props: [],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      isLoading: false,
      usuario_selecionado: "",
      users: [],
      acoes_usuario: [],
      acao_selecionada: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      editar_usuario: false,
      criar_usuario: false,
    };
  },

  mounted() {
    this.searchUsers();
  },

  methods: {
    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.searchUsers();
    },

    usuarioCriado() {
      this.setCriarUsuario(false);

      this.searchUsers();
    },

    setCriarUsuario(value) {
      let btn = document.getElementById("close_create_user");
      if (btn) {
        btn.click();
      }

      this.criar_usuario = value;
    },

    usuarioEditado() {
      this.setEditarUsuario(false);

      this.searchUsers();
    },

    setEditarUsuario(value) {
      let btn = document.getElementById("close_edit_user");
      if (btn) {
        btn.click();
      }

      this.editar_usuario = value;
    },

    searchUsers() {
      let data = {
        filtro: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/usuarios_admin/search`, data)
        .then((response) => {
          this.users = response.data.users;
          this.total = response.data.total;

          this.pagination(response.data);

          console.log("USERS");
          console.log(this.users);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.searchUsers();
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    selecionarUsuario(usuario) {
      this.usuario_selecionado = usuario;

      if (usuario.acoes_personalizadas) {
        this.acoes_usuario = JSON.parse(usuario.acoes_personalizadas);
      } else {
        this.acoes_usuario = [];
      }
    },

    addAcao() {
      this.acoes_usuario.push(this.acao_selecionada.acao);
    },

    confirmarDelete(acao, indice) {
      let html = "Deseja <b style='font-size:20px; color: red'> Remover</b> a ação <br/>" + "<b style='font-size:25px'>" + acao + "</b><br/>?";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.acoes_usuario.splice(indice, 1);
            this.update();
          }
        });
    },

    show() {
      let status1 = this.my_container.status_usuario;
      let status2 = "Ativo";
      let email = this.my_container.user.email;

      if (status1 == "Ativo") {
        status2 = "Bloqueado";
      }

      console.log("Status 1 " + status1);
      console.log("Status 2 " + status2);

      this.edit(this.my_container.nome, status1, status2, (response) => {
        if (!response.isDismissed) {
          let data = {
            nome: response.value[0],
            senha: response.value[1],
            status: response.value[2],
            id: this.my_container.id,
            user_id: this.my_container.user_id,
          };

          console.log(data);
          this.validateFields(data);
        }
      });
    },

    validateFields(data) {
      if (!data.nome || data.nome == "") {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.update(data);
      }
    },

    update() {
      let data = {
        id: this.usuario_selecionado.id,
        acoes_personalizadas: JSON.stringify(this.acoes_usuario),
      };

      axios
        .post(`/admin/users/update/acoes`, data)
        .then((response) => {
          this.showSuccessMessage("Ações atualizadas!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
